import * as React from 'react';
import { IconProps } from '../types';

const IcFunctionProdut = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={props?.fill ?? '#232F3E'} clipPath="url(#icFuncProduct)">
      <path d="M.51 5.5c2.9-1.51 5.8-3 8.7-4.5 1.07.79 2.14 1.59 3.21 2.39 1.12-.8 2.23-1.59 3.33-2.39 2.92 1.51 5.83 3.04 8.75 4.56-1 .92-1.99 1.85-2.99 2.77.99 1.15 2 2.3 2.99 3.45-2.71 1.49-5.41 3-8.12 4.49l-.05-.01c-1.11-1.17-2.22-2.34-3.32-3.51 2.47-1.31 4.93-2.63 7.4-3.95-2.62-1.49-5.27-2.91-7.9-4.38-2.65 1.45-5.29 2.9-7.93 4.36 2.48 1.32 4.96 2.63 7.43 3.95L8.7 16.37c-2.73-1.58-5.47-3.16-8.2-4.74v-.12l.03.1C1.5 10.5 2.51 9.43 3.5 8.33c-1-.94-2-1.88-3-2.83v-.1l.01.1Z" />
      <path d="M13.01 14.2c1.05 1.11 2.1 2.23 3.16 3.34 1.77-.99 3.55-1.97 5.33-2.96 0 1.3.01 2.6-.01 3.9C18.66 19.97 15.83 21.5 13 23c.01-2.93-.01-5.87.01-8.8ZM8.9 17.63c1.03-1.12 2.05-2.27 3.1-3.38.01 2.91 0 5.82.01 8.73-2.85-1.47-5.66-3.02-8.5-4.51-.01-1.32-.01-2.64 0-3.96 1.79 1.05 3.59 2.08 5.39 3.12Z" />
    </g>
    <defs>
      <clipPath id="icFuncProduct">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcFunctionProdut;
